import { FaMicrophoneAlt, FaClock, FaUsers, FaDollarSign } from 'react-icons/fa';

const features = [
    {
        id: 1,
        icon: <FaMicrophoneAlt />, // Microphone icon for Insightful Talks
        title: 'Insightful Talks',
        description: 'Hear from leading experts sharing their knowledge on trending topics.',
    },
    {
        id: 2,
        icon: <FaClock />, // Clock icon for 24/7 Access
        title: '24/7 Access',
        description: 'Enjoy access to recorded sessions at any time during the event.',
    },
    {
        id: 3,
        icon: <FaUsers />, // Users icon for Networking
        title: 'Networking',
        description: 'Connect with industry experts and professionals during the event.',
    },
    {
        id: 4,
        icon: <FaDollarSign />, // Dollar sign icon for Affordable Pricing
        title: 'Affordable Pricing',
        description: 'Our event offers great value with cost-effective pricing for all attendees.',
    },
];

export default features;